module.exports = __webpack_public_path__ + "img/cnfpt-lille.4525a4b8.jpg";